import { Controller } from "stimulus";
import Trix from "trix";

export default class extends Controller {
  static targets = ["field"];

  connect() {
    // IE <= 10 => MSIE. IE 11 => Trident
    if (navigator.userAgent.indexOf("Trident") != -1) {
      setTimeout(function(){
        this.initializeAllDisables();
      }.bind(this), 3000);
    } else {
      this.initializeAllDisables();
    }
  }

  disconnect() {
    this.fieldTarget.removeEventListener('trix-initialize', this.removeAttachFileButton);
    this.fieldTarget.removeEventListener('promote:trix-initialize', this.removeAttachFileButton);

    this.fieldTarget.removeEventListener('dragover', this.preventDragOver);
    this.fieldTarget.removeEventListener('drop', this.preventDrop);
    this.fieldTarget.removeEventListener('dragenter', this.preventDragEnter);
    this.fieldTarget.removeEventListener('dragleave', this.preventDragLeave);

    this.fieldTarget.removeEventListener('paste', this.preventPaste);
    this.fieldTarget.removeEventListener('keydown', this.preventPasteShortcuts);

    document.removeEventListener("trix-file-accept", this.preventFileAcceptance);
  }

  initializeAllDisables() {
    this.removeAttachButton();
    this.disableDragAndDrop();
    this.disablePaste();
    this.disableFileAcceptance();
  }

  removeAttachButton() {
    this.removeAttachFileButton = this.removeAttachFileButton.bind(this);

    if (this.fieldTarget.dataset.adminTrix) {
      this.fieldTarget.addEventListener('promote:trix-initialize', this.removeAttachFileButton);
      return;
    }

    this.trigger = this.element.querySelector('.trix-button--icon-attach');
    if (this.trigger) {
      this.removeAttachFileButton();
    } else {
      this.fieldTarget.addEventListener('trix-initialize', this.removeAttachFileButton);
    }
  }

  disableDragAndDrop() {
    this.preventDragOver = this.preventDragOver.bind(this);
    this.preventDrop = this.preventDrop.bind(this);
    this.preventDragEnter = this.preventDragEnter.bind(this);
    this.preventDragLeave = this.preventDragLeave.bind(this);

    this.fieldTarget.addEventListener('dragover', this.preventDragOver);
    this.fieldTarget.addEventListener('drop', this.preventDrop);
    this.fieldTarget.addEventListener('dragenter', this.preventDragEnter);
    this.fieldTarget.addEventListener('dragleave', this.preventDragLeave);
  }

  disablePaste() {
    this.preventPaste = this.preventPaste.bind(this);
    this.preventPasteShortcuts = this.preventPasteShortcuts.bind(this);

    this.fieldTarget.addEventListener('paste', this.preventPaste, true);
    this.fieldTarget.addEventListener('keydown', this.preventPasteShortcuts, true);
  }

  disableFileAcceptance() {
    this.preventFileAcceptance = this.preventFileAcceptance.bind(this);

    document.addEventListener("trix-file-accept", this.preventFileAcceptance);
  }

  removeAttachFileButton() {
    this.editor = this.fieldTarget.editor;
    this.toolbar = this.editor.element.toolbarElement;

    // AttachButton can not be passed as a static target because the element is
    // not present at the time that stimulus is loaded
    this.trigger ||= this.element.querySelector('.trix-button--icon-attach');

    if (this.trigger) {
      this.trigger.remove();
    }
  }

  preventFileAcceptance(event) {
    this.preventEvent(event);
  }

  preventDragOver(event) {
    this.preventEvent(event);
  }

  preventDrop(event) {
    this.preventEvent(event);
  }

  preventDragEnter(event) {
    this.preventEvent(event);
  }

  preventDragLeave(event) {
    this.preventEvent(event);
  }

  preventPaste(event) {
    this.preventEvent(event);
  }

  preventPasteShortcuts(event) {
    // Prevent Ctrl+V and Cmd+V
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'v') {
      this.preventEvent(event);
    }
  }

  preventEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }
}
